<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="form!">
    <h2 class="text-base font-bold text-font-primary">Affected Items</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Invoice Error Type"
            placeholder="Select Invoice Error Type"
            formControlName="invoiceErrorType"
            class="max-w-input"
        >
            @for (item of invoiceErrorTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>
        @if(showOtherInvoiceErrorType) {
        <sag-ui-textarea
            [required]="true"
            label="Other Invoice Error Type"
            formControlName="invoiceErrorTypeOtherInfo"
            class="max-w-input"
        ></sag-ui-textarea>
        }
        <app-order-line-table
            [selected]="lineItems"
            [disabled]="disabled"
            (selectionChange)="handleSelectionChange($event)"
            currency="EUR"
        ></app-order-line-table>
        @if (!disabled) {
        <div class="flex items-center justify-end max-w-[1400px]">
            <sag-ui-button [disabled]="!valid || confirmed" (click)="setConfirmed()" size="sm">{{
                confirmed ? 'Confirmed' : 'Confirm'
            }}</sag-ui-button>
        </div>
        }
    </div>
</section>
